import { PasswordResetSentForm } from '../elements/PasswordResetSentForm';

export const PasswordResetSent = () => {
  return (
    <div className="page p-auth page_a2">
      <main className="page__main">
        <div className="page__content">
          <section className="l-section">
            <div className="l-section__line">
              <div className="l-container">
                {/* ヒーロー */}
                <div className="l-hero">
                  <img
                    className="l-hero__img"
                    src="/Common_Title.jpg"
                    alt="LOUNGE RESERVATION"
                  />
                </div>

                {/* エリア群（グリッド） */}
                <div className="l-grid">
                  <PasswordResetSentForm />
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};
